module.exports = __webpack_public_path__ + "images/google.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/google.svg
// module id = 1126
// module chunks = 0